// extracted by mini-css-extract-plugin
export default {"LogoClasse":"Logo_LogoClasse__vq6gO","imageLogo":"Logo_imageLogo__IGk-6"};